/* ─────────────────────────────────────────────────────────────
   DATOS DE IDENTIFICACIÓN DEL TITULAR DEL SITIO
   Se usan en /aviso-legal, /terminos y /privacidad.
   Los campos en null no se muestran en la página: complétalos
   con los datos reales (RIF, razón social, correo, WhatsApp).
───────────────────────────────────────────────────────────── */
export const EMPRESA = {
  nombreComercial: 'Resuelve Tu Semana',
  marca:           'Rifas Jordyn',
  razonSocial:     null,   // ej. 'Inversiones XYZ, C.A.' o nombre de la persona natural titular
  rif:             null,   // ej. 'J-12345678-9' o 'V-12345678-0'
  registro:        null,   // ej. 'Registro Mercantil Primero del Estado Táchira, Tomo X, N° Y'
  domicilio:       'Estado Táchira, Venezuela',
  correo:          null,   // ej. 'contacto@rifasjordyn.com'
  whatsapp:        null,   // ej. '+58 412-0000000'
  sitioWeb:        'rifasjordyn.com',
  jurisdiccion:    'San Cristóbal, Estado Táchira',
  actualizado:     '29 de septiembre de 2026',
};
